<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <span>
          <i class="fa fa-cube"></i>
          Artikel
        </span>
      </li>
    </ul>
  </div>

  <a class="bm-btn" [routerLink]="['/', 'artikel', 'neu']">
    <i class="fa fa-plus"></i>
    Neuer Artikel
  </a>
  <a class="bm-btn" href="/warehouse/article/labelTest">
    <i class="fa fa-tags"></i>
    Etikettentest
  </a>

  <a class="bm-btn bm-btn-primary" [cdkMenuTriggerFor]="tplParams"> Artikelsuche <i class="fa fa-search"></i> </a>
  <ng-template #tplParams>
    <div cdkMenu class="bg-base-100 rounded-box z-1 w-60 shadow-sm p-2 m-0 mt-1 border border-base-300">
      <hawk-artikel-search-params class="w-full" [params]="articleParams()" #search />
      <a class="bm-btn bm-btn-primary w-full mt-2" [routerLink]="['.']" [queryParams]="search.params()" cdkMenuItem>
        Abfrage starten
      </a>
    </div>
  </ng-template>

  <div class="bm-join">
    <input
      class="bm-join-item bm-input w-40 focus:w-64 transition-all"
      type="text"
      (input)="quicksearchChanged($event)"
      placeholder="Schnellfilter"
    />
    <a class="bm-join-item bm-btn bm-btn-primary bm-btn-square" [cdkMenuTriggerFor]="tplMenu">
      <i class="fa fa-ellipsis-v"></i>
    </a>
    <ng-template #tplMenu>
      <ul
        cdkMenu
        class="bm-menu bm-dropdown-content bg-primary text-primary-content rounded-box z-1 w-52 shadow-sm p-0 m-0 mt-1"
      >
        <li class="bm-divider m-0 p-0 h-0 bm-divider-secondary"></li>
        <li>
          <a (click)="saveState()">
            <i class="fa fa-save"></i>
            Config speichern
          </a>
        </li>
        <li>
          <a (click)="deleteState()">
            <i class="fa fa-ban"></i>
            Config löschen
          </a>
        </li>
      </ul>
    </ng-template>
  </div>
</div>
<div class="page-content px-4 pb-2 flex flex-col gap-2">
  @if (xidHint()) {
    <div role="status" class="bm-alert bm-alert-info bm-alert-soft py-2" data-testid="xid-hint">
      <i class="fa fa-tag"></i>
      <span>{{ xidHint() }}</span>
    </div>
  }
  <ag-grid-angular
    class="ag-theme-quartz flex-1 min-h-0 shadow"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [rowData]="articles"
    [defaultColDef]="defaultColDef"
    [columnDefs]="colDefs"
    [rowClassRules]="rowClassRules"
    [pagination]="true"
    [rowSelection]="rowSelection"
    [initialState]="initialState"
    [paginationPageSize]="50"
    [localeText]="locale"
    [sideBar]="sideBarOptions"
    [paginationPageSizeSelector]="[50, 100, 300, 1000, 9000]"
    (gridReady)="onGridReady($event)"
  />
</div>
